import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const HindiDiwas2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/school-programs/HindiDiwas2026/8.webp`;

    const photos = [
       
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
         {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
         {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
         

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                              Topic: KRISHNA- GOKUL SE DWARKA TAK
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                Class: 6 TO 8   Date: 22 SEPTEMBER 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                               <Typography variant={'subtitle1'} align={'justify'}>
The students of Classes 6 to 8 presented a vibrant and meaningful Hindi Diwas celebration on the theme
“Krishna – Gokul se Dwarka Tak”, celebrating the life, values and timeless teachings of Lord Krishna.
  <br></br>
The celebration began with a soulful rendition of the Gopi Gopala bhajan, filling the atmosphere with
devotion and positivity. This was followed by a thought-provoking recitation of the poem Rashmirathi by
Ramdhari Singh Dinkar, which highlighted the values of courage, duty and righteousness.
  
        <br></br>
The event continued with a captivating Krishna Jhanki, depicting key moments from Krishna’s life and
bringing the divine story to life. This was followed by a graceful and inspiring performance on Dashavtar,
showcasing the ten incarnations of Lord Vishnu. The celebration was well received and warmly
appreciated by the audience.
<br></br>
The programme concluded with an inspiring message from our visionary Principal, Ms Sheeja Manoj.
Though a Mathematics and Science educator herself, she has always encouraged the importance of
language and literature and her belief in nurturing every child’s connection with the written word
continues to inspire students and teachers alike. In her words:
<br></br>
Hindi is simple, natural and the identity of our Hindustan. Read it wholeheartedly and you enter a
different world. Let us stay connected to our language and its literature, because it carries wisdom,
helps us progress and makes us good human beings.”
<br></br>
</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
“Krishna: A Journey from Playfulness to Purpose”
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default HindiDiwas2026;